import React, { useEffect } from "react";
import { Button, Grid, Paper, useTheme } from "@mui/material";
import {ReplayRounded, SearchRounded} from "@mui/icons-material";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { IExpiredRaSearchForm } from "../../models/models";
import { DMS_NAMING, REGION, EXPIRED_RA_SEARCH_INITIAL_VALUE, EXPIRED_RA_STATUS } from "../config";
import { FormAutocomplete } from "../../common/form-fields-wrappers";
import { getFormDirtyValues } from "../../utils";
import { raFilterParams } from "../state";

const ExpiredRaFilter = () => {
    const theme = useTheme();
    const {t} = useTranslation(['network', 'translation']);

    const [filterParams, setFilterParams] = useRecoilState(raFilterParams);

    const expiredSearchRaForm = useForm<IExpiredRaSearchForm>({
        defaultValues: EXPIRED_RA_SEARCH_INITIAL_VALUE
    });

    // FIXME: MOCK
    const regionOptions = REGION;
    const dmsNamingOptions = DMS_NAMING;

    /** Search Actions*/
    const handleSearch = (): void => {
        const filters = Object.assign(getFormDirtyValues(expiredSearchRaForm.formState.dirtyFields, expiredSearchRaForm.getValues()),
                                    EXPIRED_RA_STATUS);
        setFilterParams(filters);
    }

    const handleResetForm = (e: React.SyntheticEvent) => {
        e.stopPropagation();

        expiredSearchRaForm.reset();
    }

    useEffect(() => {
        setFilterParams(EXPIRED_RA_STATUS);
    },[]);

    return (
        <Paper elevation={1} sx={{p: theme.spacing(2), mb: theme.spacing(2)}}>
            <FormProvider {...expiredSearchRaForm}>
                <Grid container columnSpacing={2}>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormAutocomplete<IExpiredRaSearchForm>
                            name="region"
                            control={expiredSearchRaForm.control}
                            label={t("Region")}
                            fullWidth
                            options={regionOptions}
                            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                            getOptionLabel={(opt: any) => opt?.label}
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormAutocomplete<IExpiredRaSearchForm>
                            name="dmsNaming"
                            control={expiredSearchRaForm.control}
                            label={t("DMS Naming")}
                            fullWidth
                            options={dmsNamingOptions}
                            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                            getOptionLabel={(opt: any) => opt?.label}
                        />
                    </Grid>

                    {/* Actions */}
                    <Grid item xs={1} sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>

                        <Button variant={'text'}
                                color={"accent"}
                                startIcon={<ReplayRounded />}
                                onClick={handleResetForm}
                                sx={{mx: theme.spacing(1)}}>
                            {t('Reset')}
                        </Button>

                        <Button color={"accent"}
                                size={"icon"}
                                onClick={handleSearch}
                                sx={{mx: theme.spacing(1)}}>
                            <SearchRounded />
                        </Button>
                    </Grid>

                </Grid>
            </FormProvider>
        </Paper>
    );
}

export default ExpiredRaFilter;